import React from 'react';

const Certificates = () => {
  return (
    <div className="section-gap">
      <h1 className="text-3xl font-bold text-text">My Certificates</h1>
      <p className="text-muted mt-1">Your earned certificates will appear here.</p>
    </div>
  );
};

export default Certificates;
